module.exports = new __parcel__URL__("techno-pop.bdacc2a6.jpg").toString();